import { JDSAvatarV2Props } from './generated/interface';
import React from 'react';

export const withLogic =
  (
    Component: React.ComponentType<JDSAvatarV2Props>
  ): React.FC<JDSAvatarV2Props> =>
  (props: JDSAvatarV2Props) => {
    const trimChars = (initials: string | undefined, size: number): string => {
      if (!initials || typeof initials !== 'string' || initials.trim() === '') {
        return '';
      }
      let initialsText = '';

      const array = initials.trim().split(' ');

      if (array.length <= 1) {
        initialsText = array[0].substring(0, 2);
      } else {
        initialsText = array[0][0] + array[1][0];
      }

      initialsText = initialsText.substring(0, size);

      return initialsText.toUpperCase();
    };

    const initials = (item: JDSAvatarV2Props): string => {
      return trimChars(item.initials, item.size === 'xtra-small' ? 1 : 2);
    };
    return <Component {...props} initials={initials(props)} />;
  };
